import Vuex from 'vuex';
import Vue from 'vue';

import search from '@/Modules/search/Search';
import store from '@/Modules/store/store';

import FiltersPanelFilterList from './filters-panel-filter-list.vue';

Vue.use(Vuex);

const filtersPanel = document.getElementById('js-filters-panel');

const vm = filtersPanel
  && new Vue({
    store,
    components: {
      FiltersPanelFilterList,
    },
    delimiters: ['${', '}'],
    el: filtersPanel,

    data() {
      return {
        responseObject: search(),
        nextSearchTimeoutId: null,
        lastRequestedUrl: null,
      };
    },

    computed: {
      facets() {
        return this.responseObject.facets;
      },
      facetsVisible() {
        return this.responseObject.facets.filter(
          facet => !facet.Hidden && !facet.IsAuxilaryFacet,
        );
      },
      activeFacetValues() {
        const activeFacets = [];
        this.forEachFacetValue((facetValue, facet) => {
          if (facetValue.IsSelected && !facetValue.Hidden && !facet.Hidden) {
            activeFacets.push(facetValue);
          }
        });
        return activeFacets;
      },
      closeButtonVisible() {
        return this.$store.getters.expandSidebar;
      },
    },

    methods: {
      closeButtonClicked() {
        this.$store.dispatch('setExpandSidebar', false);
      },

      forEachFacetValue(fn) {
        for (let facetIdx = 0; facetIdx < this.facets.length; facetIdx += 1) {
          const facet = this.facets[facetIdx];
          for (
            let valueIdx = 0;
            valueIdx < facet.FacetResults.length;
            valueIdx += 1
          ) {
            const facetValue = facet.FacetResults[valueIdx];
            fn(facetValue, facet);
          }
        }
      },

      onFacetValueToggled() {
        this.performSearchDebounced();
      },

      toggleFacetValue(facet) {
        // this thows a warning, but should be okay todo: recheck
        // eslint-disable-next-line no-param-reassign
        facet.IsSelected = !facet.IsSelected;
        this.onFacetValueToggled();
      },

      clearAllFacets() {
        this.forEachFacetValue((facetValue) => {
          // eslint-disable-next-line no-param-reassign
          if (!facetValue.Hidden) {
            facetValue.IsSelected = false;
          }
        });
        this.onFacetValueToggled();
      },

      clearFacet(facetAlias) {
        this.forEachFacetValue((facetValue, facet) => {
          if (facet.FacetAlias === facetAlias) {
            // eslint-disable-next-line no-param-reassign
            facetValue.IsSelected = false;
          }
        });
        this.onFacetValueToggled();
      },

      performSearchDebounced() {
        this.responseObject.cancelRequest();
        if (this.nextSearchTimeoutId) {
          window.clearTimeout(this.nextSearchTimeoutId);
        }
        this.nextSearchTimeoutId = window.setTimeout(() => {
          this.performSearch();
          this.nextSearchTimeoutId = null;
        }, 500);
      },

      performSearch() {
        const params = this.generateQueryParameters();
        this.responseObject.updateRequest(params);
      },

      generateQueryParameters() {
        const params = {};
        let selectedCount = 0;
        this.forEachFacetValue((facetValue, facet) => {
          if (facetValue.IsSelected) {
            const paramValue = params[facet.FacetAlias] || [];
            paramValue.push(facetValue.Udi);
            params[facet.FacetAlias] = paramValue;
            if (!facetValue.Hidden && !facet.Hidden) {
              selectedCount += 1;
            }
          } else {
            params[facet.FacetAlias] = params[facet.FacetAlias] || [];
          }
        });
        store.dispatch('setAppliedFilterCount', selectedCount);
        // Reset page number to 1 on filters update.
        params.pageNumber = 1;
        return params;
      },
    },
  });

export default vm;
